export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-19.jpg'),
        title: 'SOFTWARE DEVELOPMENT AND MAINTENANCE',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: ' ENTERPRISE APPLICATION SYSTEM OPERATION AND MAINTENANCE',
      description: `<p style="font-size:1.5rem">With the continuous deepening of enterprise informatization, information systems have become massive and complex. The difficulty and pressure of enterprise application system operation and maintenance is also increasing. MaesInfo provides customized application system design and development services, and delivers projects on time and quality within budget. We can help customers identify specific requirements for application systems or products and manage and maintain their entire life cycle.
</p><p>Maesinfo relies on experienced global development teams and technical experts to provide customers with more standardized and professional customized
application systems and solutions. Our teams and experts can also make application systems run more efficiently and stable, and we can also
 respond to various failures of application systems in a timely manner.</p>`
    },
    {
      title: 'WE CAN PROVIDE:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-19.jpg')+`)"></span>
      <span class="list">
      <i></i>Industry Application Development and Maintenance<br/>
      <i></i>Customized Software Package Service<br/>
      <i></i>Mobile Applications and Embedded Development<br/>
      <i></i>Application Development of Value-added Services<br/>
      <i></i>Supply Chain Management Application Development<br/>
      <i></i>Enterprise Application Integration<br/>
      <i></i>Application System Life Cycle Support<br/>
      <i></i>Service Oriented Architecture (SOA)<br/>
      <i></i>Quality Assurance and Testing

      </span>`
    }
  ]
}
